import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from 'primereact/checkbox';

function EventAllDay({ control }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12"></div>
      <div className="col-md-8 col-12">
        <Controller
          name="all_day"
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <div className="d-flex align-items-center">
              <Checkbox
                inputId={field.name}
                checked={field.value}
                onChange={(e) => {
                  field.onChange(e.checked);
                }}
              />
              <label htmlFor={field.name} className="ms-2 pointer mb-0 disable-selection">
                All Day
              </label>
            </div>
          )}
        />
      </div>
    </div>
  );
}

export default EventAllDay;
